import { Portfolio } from "types/Transactions";
import { createCustomAction } from "typesafe-actions";

const LOGS_DATA_LOAD = "LOGS/LOGS_DATA_LOAD";
const LOGS_DATA_LOAD_SUCCESS = "LOGS/LOGS_DATA_LOAD_SUCCESS";
const LOGS_DATA_LOAD_FAIL = "LOGS/LOGS_DATA_LOAD_FAIL";

export const load = createCustomAction(LOGS_DATA_LOAD, (type) => () => ({
  type,
}));

export const loadSuccess = createCustomAction(
  LOGS_DATA_LOAD_SUCCESS,
  (type) => (data?: Portfolio[]) => ({
    type,
    data,
  })
);

export const loadFail = createCustomAction(
  LOGS_DATA_LOAD_FAIL,
  (type) => (error?: string) => ({
    type,
    error,
  })
);
